'use client'

import { Avatar, AvatarFallback, AvatarGroup, AvatarGroupCount, AvatarImage } from '@ui/web/components'
import cn from '@config/tailwind/cn'

interface AvatarStackProps {
  avatars: { src?: string; name: string }[]
  /** Total participants, which may exceed `avatars.length`. */
  total: number
  className?: string
}

const MAX_VISIBLE = 3

/** Overlapping avatars with a "+n" chip, per the grouped sender card in the designs. */
export function AvatarStack({ avatars, total, className }: AvatarStackProps) {
  const visible = avatars.slice(0, MAX_VISIBLE)
  const overflow = total - visible.length

  return (
    <AvatarGroup className={cn('srd:items-center', className)}>
      {visible.map((avatar, index) => (
        <Avatar key={`${avatar.name}-${index}`}>
          <AvatarImage src={avatar.src} alt='' />
          <AvatarFallback>{avatar.name.charAt(0).toUpperCase()}</AvatarFallback>
        </Avatar>
      ))}

      {overflow > 0 && <AvatarGroupCount>+{overflow > 99 ? 99 : overflow}</AvatarGroupCount>}
    </AvatarGroup>
  )
}
